import { useMemo } from "react"
import { useQuery } from "urql"

import type { LocationCarrierPreferenceListInput, LocationCarrierPreferenceListQuery } from "@/graphql/codegen/graphql"
import { LocationCarrierPreferenceListDocument } from "@/graphql/codegen/graphql"

type LocationCarrierPreferenceSuccess = Extract<
  LocationCarrierPreferenceListQuery["locationCarrierPreference"]["list"],
  { __typename: "LocationCarrierPreferenceListSuccess" }
>

type CarrierPreferenceItem = NonNullable<LocationCarrierPreferenceSuccess["locationCarrierPreferences"]>[number]

interface UseGetCarrierPreferencesResult {
  preferences: CarrierPreferenceItem[]
  isFetchingPreferences: boolean
  refetchPreferences: () => void
}

export const useGetCarrierPreferences = (locationId: string): UseGetCarrierPreferencesResult => {
  const [{ data, fetching }, reexecuteQuery] = useQuery<
    LocationCarrierPreferenceListQuery,
    { input: LocationCarrierPreferenceListInput }
  >({
    query: LocationCarrierPreferenceListDocument,
    variables: {
      input: {
        filter: {
          shipToLocationId: locationId,
        },
      },
    },
    pause: !locationId,
  })

  const preferences = useMemo(() => {
    if (data?.locationCarrierPreference.list.__typename === "LocationCarrierPreferenceListSuccess") {
      return data.locationCarrierPreference.list.locationCarrierPreferences
    }
    return []
  }, [data])

  const refetchPreferences = () => {
    reexecuteQuery({ requestPolicy: "network-only" })
  }

  return {
    preferences,
    isFetchingPreferences: fetching,
    refetchPreferences,
  }
}
